// Auto-gap: keys used in code but missing from en-US pages/fix_*
export default {
  'pages.admin.providerCard.badge.commercialLicense': 'Commercial license',
  'pages.admin.providerCard.config.commercialLicense': 'Commercial license',
  'pages.admin.providerCard.config.funasrAddr': 'FunASR URI',
  'pages.admin.providerCard.config.no': 'No',
  'pages.admin.providerCard.config.yes': 'Yes',
  'pages.admin.providerModal.funasr.addr.label': 'FunASR address (host:port) *',
  'pages.admin.providerModal.funasr.addr.required': 'Please enter FunASR URI (host:port)',
  'pages.admin.user.devices': 'Devices',
  'pages.admin.user.devicesModal.title': '{username}\'s devices',
  'pages.admin.user.knowledgeBase.off': 'Off',
  'pages.admin.user.knowledgeBase.on': 'On',
  'pages.admin.user.knowledgeBaseDocMaxCount': 'Docs per KB limit',
  'pages.admin.user.knowledgeBaseDocMaxCount.label': 'Max documents per knowledge base (min with system limit)',
  'pages.admin.user.knowledgeBaseEnabled': 'Knowledge base',
  'pages.admin.user.knowledgeBaseEnabled.label': 'Allow knowledge base',
  'pages.admin.user.knowledgeBaseMaxCount': 'KB count limit',
  'pages.admin.user.knowledgeBaseMaxCount.label': 'Max knowledge bases for user (min with system limit)',
  'pages.admin.user.supplierCode': 'License code',
  'pages.admin.user.supplierCode.label': 'License code',
  'pages.admin.user.supplierCode.tooltip': 'Enterprise license code; non-empty marks this user as the tenant admin. Clear to unbind.',
  'pages.agentMemorySetting.button.reset': 'Reset',
  'pages.agentMemorySetting.button.save': 'Save',
  'pages.agentMemorySetting.save.error': 'Save failed',
  'pages.agentMemorySetting.save.loadFailed': 'Failed to load agent',
  'pages.agentMemorySetting.save.missingId': 'Missing agent id; cannot save',
  'pages.agentMemorySetting.save.success': 'Saved',
  'pages.agentMemorySetting.title': 'Configure memory',
  'pages.agentMemorySetting.unavailable': 'Memory is disabled system-wide. Ask an admin to enable it in System Config.',
  'pages.agents.card.configMemory': 'Configure memory',
  'pages.agents.delete.confirm.all': 'Delete this speaker and all samples?',
  'pages.agentSetting.asr.label': 'Speech recognition model',
  'pages.agentSetting.asr.placeholder': 'Select ASR provider',
  'pages.agentSetting.asr.required': 'Please select an ASR provider',
  'pages.agentSetting.asr.tip': 'Same as ASR providers configured in admin; affects on-device speech recognition.',
  'pages.agentSetting.asr.title': 'ASR · Speech recognition',
  'pages.agentSetting.memory.clear.error': 'Failed to clear memory',
  'pages.agentSetting.memory.clear.success': 'Memory cleared',
  'pages.agentSetting.memory.current.label.long': 'Long-term memory',
  'pages.agentSetting.memory.edit.error': 'Failed to update memory',
  'pages.agentSetting.minorBand.label': 'Minor age band',
  'pages.agentSetting.minorBand.tip':
    'Stricter of agent/device wins. Teen (~12–17): ~120 min chat by default. Child (under ~12): stricter content, ~60 min rest cycle. Off = no agent-side limit.',
  'pages.agentSetting.minorBand.off': 'Off',
  'pages.agentSetting.minorBand.teen': 'Teen',
  'pages.agentSetting.minorBand.child': 'Child',
  'pages.agentSetting.minorBand.teenDesc':
    '~12–17: minor-safe baseline, light social guidance OK; default ~120 min chat then 30 min rest',
  'pages.agentSetting.minorBand.childDesc':
    'Under ~12: stricter content/privacy and kid-friendly tone; default ~60 min chat then 30 min rest',
  'pages.agentSetting.minorBand.compareTip':
    'Child is stricter than Teen (broader blocklist, shorter session). When both sides are on, the stricter band wins.',
  'pages.agentSetting.minorBand.saveWarn': 'Agent saved, but minor band was not updated',
  'pages.agentSetting.memory.longTerm.bool.no': 'No',
  'pages.agentSetting.memory.longTerm.bool.yes': 'Yes',
  'pages.agentSetting.memory.longTerm.clear.tip': 'Long-term memory marked for clear; click Save to apply',
  'pages.agentSetting.memory.longTerm.dash': '—',
  'pages.agentSetting.memory.longTerm.emptyProfile': 'No structured profile yet. It fills after chats with collection on, or edit manually via “Edit memory”.',
  'pages.agentSetting.memory.longTerm.field.age': 'Age / age range',
  'pages.agentSetting.memory.longTerm.field.birthday': 'Birthday',
  'pages.agentSetting.memory.longTerm.field.communication_style': 'Communication style',
  'pages.agentSetting.memory.longTerm.field.created_at': 'Created at',
  'pages.agentSetting.memory.longTerm.field.dislikes': 'Dislikes / avoid',
  'pages.agentSetting.memory.longTerm.field.education': 'Education',
  'pages.agentSetting.memory.longTerm.field.extra_memory': 'Other long-term notes (semicolon or newline)',
  'pages.agentSetting.memory.longTerm.field.family': 'Family',
  'pages.agentSetting.memory.longTerm.field.gender': 'Gender',
  'pages.agentSetting.memory.longTerm.field.goals': 'Goals / wishes',
  'pages.agentSetting.memory.longTerm.field.goals_short': 'Goals',
  'pages.agentSetting.memory.longTerm.field.health_notes': 'Health / allergy notes',
  'pages.agentSetting.memory.longTerm.field.health_notes_short': 'Health notes',
  'pages.agentSetting.memory.longTerm.field.hobbies': 'Hobbies (multi-value; Enter or comma)',
  'pages.agentSetting.memory.longTerm.field.hobbies_short': 'Hobbies',
  'pages.agentSetting.memory.longTerm.field.important_dates': 'Important dates',
  'pages.agentSetting.memory.longTerm.field.important_dates_short': 'Important dates',
  'pages.agentSetting.memory.longTerm.field.is_locked': 'Lock profile (read-only; server collection stops updating)',
  'pages.agentSetting.memory.longTerm.field.is_locked_short': 'Locked (read-only)',
  'pages.agentSetting.memory.longTerm.field.last_updated': 'Last updated',
  'pages.agentSetting.memory.longTerm.field.location': 'Location',
  'pages.agentSetting.memory.longTerm.field.mbti': 'MBTI',
  'pages.agentSetting.memory.longTerm.field.nickname': 'Nickname',
  'pages.agentSetting.memory.longTerm.field.occupation': 'Occupation',
  'pages.agentSetting.memory.longTerm.field.personality': 'Personality',
  'pages.agentSetting.memory.longTerm.field.personality_short': 'Personality',
  'pages.agentSetting.memory.longTerm.field.pets': 'Pets',
  'pages.agentSetting.memory.longTerm.field.pets_short': 'Pets',
  'pages.agentSetting.memory.longTerm.field.preferences': 'Preferences',
  'pages.agentSetting.memory.longTerm.field.relationships': 'Important relationships',
  'pages.agentSetting.memory.longTerm.field.timezone': 'Timezone',
  'pages.agentSetting.memory.longTerm.field.version': 'Version',
  'pages.agentSetting.memory.longTerm.field.zodiac': 'Zodiac',
  'pages.agentSetting.memory.longTerm.formHint': 'Edits sync to the JSON draft; take effect after saving the agent. Metadata like created_at/version is kept when JSON is valid.',
  'pages.agentSetting.memory.longTerm.help': 'Long-term memory creates summary anchors after chats and retrieves them when relevant. Turning off stops write/retrieve but does not wipe existing memory.',
  'pages.agentSetting.memory.longTerm.invalidJson': 'Content is not valid JSON; switched to raw text editing.',
  'pages.agentSetting.memory.longTerm.jsonEditor.hint': 'Edit JSON directly; switching back to the form parses and fills fields (must be a valid object).',
  'pages.agentSetting.memory.longTerm.mode.form': 'Form',
  'pages.agentSetting.memory.longTerm.mode.json': 'JSON source',
  'pages.agentSetting.memory.longTerm.placeholder.age': 'e.g. 25, college student',
  'pages.agentSetting.memory.longTerm.placeholder.extra_memory': 'e.g. allergic to cat hair; usually home on weekends',
  'pages.agentSetting.memory.longTerm.placeholder.nickname': 'e.g. Alex',
  'pages.agentSetting.memory.longTerm.placeholder.tags': 'Type and press Enter',
  'pages.agentSetting.memory.longTerm.profile.label': 'User profile (long-term memory)',
  'pages.agentSetting.memory.longTerm.section.basic': 'Basics',
  'pages.agentSetting.memory.longTerm.section.extra': 'Free-form notes',
  'pages.agentSetting.memory.longTerm.section.lifestyle': 'Personality & lifestyle',
  'pages.agentSetting.memory.longTerm.section.meta': 'Notes & metadata',
  'pages.agentSetting.memory.longTerm.section.prefs': 'Preferences & habits',
  'pages.agentSetting.memory.longTerm.section.relations': 'Relationships',
  'pages.agentSetting.memory.type.longTerm': 'Long-term memory',
  'pages.agentSetting.recognitionSpeed.fast': 'Fast',
  'pages.agentSetting.recognitionSpeed.normal': 'Normal',
  'pages.agentSetting.recognitionSpeed.slow': 'Patient',
  'pages.agentSetting.tts.label': 'Speech synthesis model',
  'pages.agentSetting.tts.title': 'TTS · Speech synthesis',
  'pages.agentSetting.voiceType.cloneTag': 'Clone',
  'pages.agentSetting.voiceType.cloneTagHint': 'Items tagged “Clone” are your custom voices; use the filter above to show clones only.',
  'pages.agentSetting.voiceType.filterAll': 'All',
  'pages.agentSetting.voiceType.filterClone': 'My clones',
  'pages.agentSetting.voiceType.filterPreset': 'System presets',
  'pages.agentSetting.voiceType.noCloneHint': 'No clone voices for this language. Go to',
  'pages.agentSetting.voiceType.noCloneHintSuffix': 'to create one',
  'pages.agentSetting.voiceType.noCloneLink': 'Voice clone',
  'pages.common.confirm': 'OK',
  'pages.deviceBound.activatedAt': 'Activated at',
  'pages.deviceBound.agent.action': 'Agents',
  'pages.deviceBound.agent.loadFail': 'Failed to load agent details',
  'pages.deviceBound.agent.noAgent': 'No agent bound to this device',
  'pages.deviceBound.agent.title': 'Agents',
  'pages.deviceBound.boardType': 'Board type',
  'pages.deviceBound.online': 'Online status',
  'pages.deviceBound.online.off': 'Offline',
  'pages.deviceBound.online.on': 'Online',
  'pages.deviceBound.operations': 'Actions',
  'pages.deviceBound.productName': 'Product name',
  'pages.deviceBound.safety.action': 'Guard',
  'pages.deviceBound.aaUsage.action': 'Usage',
  'pages.deviceBound.more.action': 'More',
  'pages.deviceBound.safety.title': 'Device guard',
  'pages.deviceBound.safety.minorBand': 'Age band',
  'pages.deviceBound.safety.band.off': 'Off',
  'pages.deviceBound.safety.band.teen': 'Teen',
  'pages.deviceBound.safety.band.child': 'Child',
  'pages.deviceBound.safety.effectiveBand': 'Effective band',
  'pages.deviceBound.safety.sources': 'Sources',
  'pages.deviceBound.safety.source.agent': 'Agent',
  'pages.deviceBound.safety.source.device': 'Device',
  'pages.deviceBound.safety.source.withBand': '{side}: {band}',
  'pages.deviceBound.safety.agentBand': 'Agent band',
  'pages.deviceBound.safety.deviceBandCurrent': 'Device band',
  'pages.deviceBound.safety.deviceBandEdit': 'Set device band',
  'pages.deviceBound.safety.restStatus': 'Anti-addiction',
  'pages.deviceBound.safety.resting': 'Resting, {duration} left',
  'pages.deviceBound.safety.dailyExhausted': 'Daily limit reached, {duration} left',
  'pages.deviceBound.safety.notRestricted': 'Not restricted',
  'pages.deviceBound.safety.cycleUsage': 'Effective chat (cycle)',
  'pages.deviceBound.safety.cycleUsageTip':
    '“Cycle” means cumulative effective chat since the last rest ended—not calendar today. Default ~2h chat then ~30m rest; midnight does NOT reset the cycle; a new cycle starts after rest ends.',
  'pages.deviceBound.safety.dailyUsage': 'Effective chat (today)',
  'pages.deviceBound.safety.dailyUsageTip':
    '“Today” uses the configured timezone (default Asia/Shanghai). Daily hard cap only applies when daily limit is enabled; independent from the rest cycle.',
  'pages.deviceBound.safety.usageRuleTip':
    'Usage tip: “Cycle” is not a calendar day and does not reset at midnight; it clears after rest. “Today” is the optional daily total.',
  'pages.deviceBound.safety.antiAddictionTip':
    'Primary rule accumulates effective chat in a rest cycle (~2h chat → ~30m rest by default), not by calendar day. Midnight does not clear the cycle; a new cycle starts after rest. “Daily limit reached” is the calendar daily cap.',
  'pages.deviceBound.safety.cycleUsedMinutes': 'Cycle effective chat {min} min',
  'pages.deviceBound.safety.cycleUsedOfLimit': 'Cycle effective chat {used}/{limit} min',
  'pages.devices.guard.cycleUsage': 'Effective chat (cycle)',
  'pages.devices.guard.cycleUsageTip':
    '“Cycle” means cumulative effective chat since the last rest ended—not calendar today. Default ~2h chat then ~30m rest; midnight does NOT reset the cycle.',
  'pages.devices.guard.dailyUsage': 'Effective chat (today)',
  'pages.devices.guard.dailyUsageTip':
    '“Today” uses the configured timezone (default Asia/Shanghai). Daily hard cap only when daily limit is enabled.',
  'pages.devices.guard.usageRuleTip':
    'Usage tip: “Cycle” is not a calendar day and does not reset at midnight; it clears after rest. “Today” is the optional daily total.',
  'pages.devices.guard.resting': 'Resting, {duration} left',
  'pages.devices.guard.dailyExhausted': 'Daily limit reached, {duration} left',
  'pages.devices.guard.hint':
    'Device-only setting; stricter of agent/device wins. Child is stricter than Teen (~60 min rest cycle vs ~120 min). “Cycle” usage is not calendar today and does not reset at midnight—only after rest. “Today” is the optional daily total. Admins can change global policy and grants.',
  'pages.devices.guard.band.offDesc': 'No device-side age-band content rules',
  'pages.devices.guard.band.teenDesc':
    '~12–17: minor-safe baseline, light social guidance OK; default ~120 min chat then 30 min rest',
  'pages.devices.guard.band.childDesc':
    'Under ~12: stricter content/privacy and kid-friendly tone; default ~60 min chat then 30 min rest',
  'pages.devices.guard.band.compareTip':
    'Tip: younger kids → Child; middle/high school → Teen. Child is stricter; when both sides are on, the stricter band wins.',
  'pages.deviceBound.safety.grantStatus': 'Grant status',
  'pages.deviceBound.safety.grantNone': 'No grant',
  'pages.deviceBound.safety.grantActive': 'Granted until {until}',
  'pages.deviceBound.safety.grantTag': 'Granted',
  'pages.deviceBound.safety.grantRounds': ', {rounds} rounds left',
  'pages.deviceBound.safety.unlock': 'Unlock',
  'pages.deviceBound.safety.unlockTitle': 'Grant unlock exemption',
  'pages.deviceBound.safety.unlockSeconds': 'Extra seconds',
  'pages.deviceBound.safety.unlockReason': 'Reason',
  'pages.deviceBound.safety.unlockReasonRequired': 'Reason is required',
  'pages.deviceBound.safety.unlockSuccess': 'Unlock grant issued',
  'pages.deviceBound.safety.unlockFail': 'Unlock failed',
  'pages.deviceBound.safety.override': 'Policy override',
  'pages.deviceBound.safety.overrideMode': 'Override mode',
  'pages.deviceBound.safety.override.hint':
    'Affects this device’s anti-addiction duration only; age-band content filtering stays on. Priority: custom > child profile > global.',
  'pages.deviceBound.safety.override.inherit': 'Inherit',
  'pages.deviceBound.safety.override.inheritDesc':
    'Default. Use global anti-addiction; child band uses the stricter child profile (~60 min chat / 30 min rest).',
  'pages.deviceBound.safety.override.disable': 'Disable anti-addiction',
  'pages.deviceBound.safety.override.disableDesc':
    'No session/rest/daily time limits on this device. Age-band lexicons and prompts still apply.',
  'pages.deviceBound.safety.override.custom': 'Custom',
  'pages.deviceBound.safety.override.customDesc':
    'Set cycle limit, rest duration, and daily limit for this device only (overrides global and child profile).',
  'pages.deviceBound.safety.override.cycle': 'Cycle limit (min)',
  'pages.deviceBound.safety.override.rest': 'Rest duration (min)',
  'pages.deviceBound.safety.override.daily': 'Daily limit (min)',
  'pages.deviceBound.safety.override.dailyTip': '0 means no daily total limit',
  'pages.deviceBound.safety.override.howto':
    'Tip: use Inherit for most devices; Disable (or a temporary grant) to relax time limits; Custom for a per-device schedule.',
  'pages.deviceBound.safety.overrideSave': 'Save override',
  'pages.deviceBound.safety.overrideSaveTip':
    'This button saves policy override only. Use the footer “Save age band” for the device band; they are independent and must be saved separately.',
  'pages.deviceBound.safety.overrideSuccess': 'Override saved',
  'pages.deviceBound.safety.overrideFail': 'Failed to save override',
  'pages.deviceBound.safety.saveBand': 'Save age band',
  'pages.deviceBound.safety.saveBandTip':
    'Footer “Save age band” writes the device band only; policy override requires “Save override” above.',
  'pages.deviceBound.safety.hint':
    'Effective band is the stricter of agent and device; only changes this device. Saving age band and saving override are separate actions—click each button as needed. “Cycle” anti-addiction is not calendar today (~2h chat then ~30m rest by default) and does not reset at midnight; “Today” is the calendar daily total.',
  'pages.deviceBound.safety.loadFail': 'Failed to load guard status',
  'pages.deviceBound.safety.saveSuccess': 'Device band saved',
  'pages.deviceBound.safety.saveFail': 'Save failed',
  'pages.deviceBound.tenantName': 'Tenant',
  'pages.deviceBound.tenantName.placeholder': 'Enter tenant name or code',
  'pages.deviceBound.title': 'Bound devices',
  'pages.deviceBound.unbind': 'Unbind',
  'pages.deviceBound.unbind.confirm': 'Unbind this device? It must be activated again to re-bind.',
  'pages.deviceBound.unbind.fail': 'Unbind failed',
  'pages.deviceBound.unbind.success': 'Unbound',
  'pages.deviceBound.usage.action': 'Usage',
  'pages.deviceBound.usage.dialogueTotal': 'Total dialogues',
  'pages.deviceBound.usage.loadFail': 'Failed to load usage',
  'pages.deviceBound.usage.title': 'Usage',
  'pages.deviceBound.usage.tokens30Days': 'Tokens (30 days)',
  'pages.deviceBound.usage.tokens7Days': 'Tokens (7 days)',
  'pages.deviceBound.usage.tokensToday': 'Tokens (today)',
  'pages.deviceBound.usage.tokensTotal': 'Tokens (total)',
  'pages.deviceBound.usage.username': 'Bound user',
  'pages.deviceBound.username': 'Owner',
  'pages.deviceBound.username.placeholder': 'Enter username',
  'pages.deviceBound.version': 'Version',
  'pages.devices.bridge.connectorOffline': 'Bound; run SaiboAssistant on PC and enter the pair code below',
  'pages.devices.bridge.copyPairCode': 'Copy pair code',
  'pages.devices.bridge.notConfigured': 'Device not bound or no agent linked',
  'pages.devices.bridge.pairCode': 'Pair code',
  'pages.devices.bridge.ready': 'Agent bound, connector online',
  'pages.devices.bridge.runtime': 'Lobster chat (auto-detected after device selects it)',
  'pages.devices.copy.iccidEmpty': 'ICCID is empty; cannot copy',
  'pages.devices.copy.iccidSuccess': 'ICCID copied',
  'pages.devices.copy.macEmpty': 'MAC is empty; cannot copy',
  'pages.devices.copy.pairCodeEmpty': 'Pair code is empty; cannot copy',
  'pages.devices.copy.pairCodeSuccess': 'Pair code copied',
  'pages.devices.device.iccid': 'SIM ICCID',
  'pages.knowledgeBase.actions.delete': 'Delete',
  'pages.knowledgeBase.actions.edit': 'Edit',
  'pages.knowledgeBase.actions.recallTest': 'Recall test',
  'pages.knowledgeBase.actions.upload': 'Upload document',
  'pages.knowledgeBase.actions.view': 'View',
  'pages.knowledgeBase.chunks.actions.add': 'Add chunk',
  'pages.knowledgeBase.chunks.actions.delete': 'Delete',
  'pages.knowledgeBase.chunks.actions.edit': 'Edit',
  'pages.knowledgeBase.chunks.actions.save': 'Save',
  'pages.knowledgeBase.chunks.add.contentRequired': 'Please enter chunk content',
  'pages.knowledgeBase.chunks.add.emptyHint': 'Cannot append while this document has no chunks. Finish indexing or change page.',
  'pages.knowledgeBase.chunks.add.error': 'Failed to add chunk',
  'pages.knowledgeBase.chunks.add.modalHint': 'Content is written under the same logical document in the vector store and embedded automatically.',
  'pages.knowledgeBase.chunks.add.modalTitle': 'Add chunk',
  'pages.knowledgeBase.chunks.add.needAnchor': 'No chunk metadata on this page. Refresh or re-enter from the document list.',
  'pages.knowledgeBase.chunks.add.placeholder': 'Enter new chunk text…',
  'pages.knowledgeBase.chunks.add.scopeHint': '“Add chunk” requires opening this page from a document (with document context). In the all-chunks view you can only edit or delete.',
  'pages.knowledgeBase.chunks.add.success': 'Chunk added',
  'pages.knowledgeBase.chunks.columns.actions': 'Actions',
  'pages.knowledgeBase.chunks.columns.content': 'Content',
  'pages.knowledgeBase.chunks.columns.index': '#',
  'pages.knowledgeBase.chunks.columns.metadata': 'Metadata',
  'pages.knowledgeBase.chunks.delete.confirmDesc': 'This cannot be undone. The chunk will no longer be retrieved.',
  'pages.knowledgeBase.chunks.delete.confirmTitle': 'Delete this chunk?',
  'pages.knowledgeBase.chunks.delete.error': 'Failed to delete chunk',
  'pages.knowledgeBase.chunks.delete.success': 'Chunk deleted',
  'pages.knowledgeBase.chunks.edit.contentRequired': 'Content cannot be empty',
  'pages.knowledgeBase.chunks.edit.error': 'Update failed',
  'pages.knowledgeBase.chunks.edit.success': 'Updated',
  'pages.knowledgeBase.chunks.list.error': 'Failed to load chunks',
  'pages.knowledgeBase.chunks.metadata.chars': 'Chars:',
  'pages.knowledgeBase.chunks.metadata.createdAt': 'Created:',
  'pages.knowledgeBase.chunks.metadata.filename': 'File:',
  'pages.knowledgeBase.chunks.metadata.lines': 'Lines:',
  'pages.knowledgeBase.chunks.metadata.updatedAt': 'Updated:',
  'pages.knowledgeBase.chunks.metadata.words': 'Words:',
  'pages.knowledgeBase.chunks.page.title': 'Knowledge base chunks',
  'pages.knowledgeBase.chunks.pagination.total': '{total} total',
  'pages.knowledgeBase.chunks.sort.asc': 'Created: oldest → newest (click for descending)',
  'pages.knowledgeBase.chunks.sort.desc': 'Created: newest → oldest (click for ascending)',
  'pages.knowledgeBase.columns.actions': 'Actions',
  'pages.knowledgeBase.columns.createdAt': 'Created at',
  'pages.knowledgeBase.columns.description': 'Description',
  'pages.knowledgeBase.columns.documentCount': 'Documents',
  'pages.knowledgeBase.columns.name': 'Name',
  'pages.knowledgeBase.columns.state': 'Status',
  'pages.knowledgeBase.create.button': 'New knowledge base',
  'pages.knowledgeBase.create.modalTitle': 'New knowledge base',
  'pages.knowledgeBase.create.success': 'Created',
  'pages.knowledgeBase.delete.confirmTitle': 'Delete knowledge base?',
  'pages.knowledgeBase.delete.success': 'Deleted',
  'pages.knowledgeBase.documents.actions.viewChunks': 'View chunks',
  'pages.knowledgeBase.documents.archiveAlert': 'Original upload archiving is on. File copies are stored under user/knowledge-base directories on the server.',
  'pages.knowledgeBase.documents.columns.actions': 'Actions',
  'pages.knowledgeBase.documents.columns.createdAt': 'Created at',
  'pages.knowledgeBase.documents.columns.name': 'Document name',
  'pages.knowledgeBase.documents.columns.ragStoredFilename': 'RAG stored filename',
  'pages.knowledgeBase.documents.columns.size': 'Size',
  'pages.knowledgeBase.documents.columns.state': 'Status',
  'pages.knowledgeBase.documents.delete.confirmTitle': 'Delete document?',
  'pages.knowledgeBase.documents.delete.success': 'Deleted',
  'pages.knowledgeBase.documents.list.error': 'Failed to load documents',
  'pages.knowledgeBase.documents.page.title': 'Knowledge base documents',
  'pages.knowledgeBase.documents.state.failed': 'Failed',
  'pages.knowledgeBase.documents.state.processing': 'Processing',
  'pages.knowledgeBase.documents.state.ready': 'Ready',
  'pages.knowledgeBase.edit.modalTitle': 'Edit knowledge base',
  'pages.knowledgeBase.edit.success': 'Updated',
  'pages.knowledgeBase.form.description': 'Description',
  'pages.knowledgeBase.form.descriptionPlaceholder': 'Enter description',
  'pages.knowledgeBase.form.descriptionRequired': 'Please enter a description',
  'pages.knowledgeBase.form.name': 'Name',
  'pages.knowledgeBase.form.namePlaceholder': 'Enter name',
  'pages.knowledgeBase.form.nameRequired': 'Please enter a name',
  'pages.knowledgeBase.list.error': 'Failed to load knowledge bases',
  'pages.knowledgeBase.page.archiveTip': 'Upload archiving is enabled: the server keeps file copies by user, knowledge base, and time for audit.',
  'pages.knowledgeBase.page.disabledAlert': 'Knowledge base is not enabled for this account (view/delete only). Ask an admin to enable “Allow knowledge base”.',
  'pages.knowledgeBase.page.tip': 'Up to {maxKb} knowledge bases per user and {maxDoc} documents each; effective limit is the min of mcp_rag config and user quota.',
  'pages.knowledgeBase.page.title': 'Knowledge base',
  'pages.knowledgeBase.recall.chunkIndex': 'Chunk',
  'pages.knowledgeBase.recall.empty': 'No hits. Try other keywords or confirm documents are indexed.',
  'pages.knowledgeBase.recall.error': 'Search failed',
  'pages.knowledgeBase.recall.hitCount': '{count} hits',
  'pages.knowledgeBase.recall.modalTitle': 'Recall test — {name}',
  'pages.knowledgeBase.recall.queryPlaceholder': 'Enter query and press Enter',
  'pages.knowledgeBase.recall.queryRequired': 'Please enter a query',
  'pages.knowledgeBase.recall.score': 'Score',
  'pages.knowledgeBase.recall.search': 'Search',
  'pages.knowledgeBase.recall.summary': 'Summary',
  'pages.knowledgeBase.recall.tip': 'Search the most relevant chunks in indexed documents to validate recall quality.',
  'pages.knowledgeBase.save.error': 'Save failed',
  'pages.knowledgeBase.state.disabled': 'Off',
  'pages.knowledgeBase.state.draft': 'No upload',
  'pages.knowledgeBase.state.enabled': 'On',
  'pages.knowledgeBase.upload.accepted': 'Upload accepted. Parsing in background; status will refresh automatically.',
  'pages.knowledgeBase.upload.docLimit': 'Document limit reached ({n}). Delete some documents first.',
  'pages.knowledgeBase.upload.error': 'Upload failed',
  'pages.knowledgeBase.upload.indexError': 'Document parsing failed',
  'pages.knowledgeBase.upload.modalTip': 'Max 15MB per file; document count is limited by system config (current max {n}).',
  'pages.knowledgeBase.upload.modalTitle': 'Upload document',
  'pages.knowledgeBase.upload.phase.uploading': 'Uploading…',
  'pages.knowledgeBase.upload.required': 'Please select a document',
  'pages.knowledgeBase.upload.selectButton': 'Select txt, md, pdf, or docx',
  'pages.knowledgeBase.upload.sizeError': 'File must be ≤ 15MB',
  'pages.knowledgeBase.upload.typeError': 'Only txt, md, pdf, and docx are supported',
  'pages.settings.basicInfo.newNicknameRequired': 'Please enter a new nickname',
  'pages.settings.basicInfo.nicknameChangeError': 'Failed to update nickname',
  'pages.settings.basicInfo.nicknameLength': 'Nickname must be 2–20 characters',
  'pages.settings.deleteAccount.error': 'Failed to delete account',
  'pages.settings.fetchProfile.error': 'Failed to load profile',
  'pages.settings.password.changeError': 'Failed to change password',
  'pages.settings.password.changeSuccess': 'Password changed',
  'pages.speaker.addSample': 'Add sample',
  'pages.speaker.deleteSample': 'Delete sample',
  'pages.speaker.deleteSpeaker': 'Delete speaker',
  'pages.speaker.selectWavTip': 'Please select a WAV file',
  'pages.speaker.speakerList': 'Voiceprint speakers',
  'pages.voiceClone.colExtra': 'Extra fields',
  'pages.voiceClone.colPath': 'Local path',
  'pages.voiceClone.playSample': 'Play sample',
  'pages.voiceClone.playSampleFailed': 'Failed to play sample',
  'pages.voiceClone.playSampleMissing': 'No linked sample to play',
  'pages.voiceClone.playSampleStop': 'Stop',

  // pages/menu keys missing from en-US base modules
  'menu.admin.sub-page': 'Admin sub-page',
  'pages.agentSetting.voiceType.groupClone': 'My cloned voices',
  'pages.agentSetting.voiceType.groupPreset': 'System preset voices',
  'pages.agentSetting.memory.longTerm.content.placeholder':
    'No long_term_memory yet. It is generated after chats, or click Edit to add manually.',
  'pages.agentSetting.memory.longTerm.content.editPlaceholder':
    'Enter long_term_memory content (JSON recommended)',
  'pages.agentSetting.memory.longTerm.backToForm': 'Back to form',
  'pages.agentSetting.memory.longTerm.switchJson': 'Switch to JSON editor',
  'pages.admin.providerCard.voices.count': ' voices',
  'pages.knowledgeBase.upload.success': 'Upload successful',
  'pages.knowledgeBase.upload.singleLimit': 'Only one document is supported in this version. Delete the existing document first.',
};
